// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"448":"a1629351","844":"6e5ccbd7"}[chunkId] + ".css";
};